import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/c54a7b7/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`A dashboard widget offers a summary of a platform’s functionality, status, or individual service. Widgets provide actionable information that helps the user quickly accomplish a task or track key metrics.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainer"
    }}>{`Maintainer:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://www.github.com/adrianamorales"
      }}>{`Adriana Morales`}</a></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "60.83333333333334%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAACB0lEQVQoz4VTS2sUQRjc/+bVX+AtF8EoKrjRRQiaKD7Av+E9RBEFETx686BoTJQIHnYnm92dR7+7p/yqOzvRg9jQ9Mx0ddVX9fWMNu/cA+fGjQmu3d3B5NEzbO0+wa2dxxhz7pZ168FT3Nx+iCu3C/7q5H5eN2W9uDHGhUvXcXm8jRFktJ2GNhb/G/0/vr/7OMXLD78QBTBqlIPSBk3bIcSIGBNCiHA+yHuA1hbGBhFVmC+WGZtSgnUBy7qVPTfItdpj1BkPZWSzdfBCxA0SEui9gWpWWHZzATvMTmtUizbjggg3yufnlHpxuBCMIWFA3TmQmNX1fZ8nB8GqadDWlRy2WDYaxhUyTiVnSMbhfC2EthDG1P+REgnP8zECUsZBi23GQ2EvZC7EvwpIMsk16sQ37a1VedA6L5l1pUJ5J1ALKaPIkvFckXnynHHhjFAUjRCEM7WYA4+SqRm+0daqbjCtThAEqxDw9ugAh5+PpFII1orlWAjZEIbLPIrdPnfwZNlm0DrPan6K78c/8/P+1xkOVYdXz1/gx/EUc2koK1SlwpDzYDXZghCQaCUV5mZpdjINxBxfDhRe733D+zefUIlwo33+PlimTdoiEa+HlTVPV4InIQWZV2lgQjVr4FzJOHd7aIoJ+U/J9y6kXLaxXsA+V0WRdeC8uCyg1dI4XhtbbHItewG/Abe/iJtAtzSKAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of a dashboard using widgets",
        "title": "Example of a dashboard using widgets",
        "src": "/static/f62efcb15c51e0c4170eaa3b8ac4b4d5/c801a/sample_dashboard.png",
        "srcSet": ["/static/f62efcb15c51e0c4170eaa3b8ac4b4d5/1a057/sample_dashboard.png 288w", "/static/f62efcb15c51e0c4170eaa3b8ac4b4d5/8418d/sample_dashboard.png 576w", "/static/f62efcb15c51e0c4170eaa3b8ac4b4d5/c801a/sample_dashboard.png 1152w", "/static/f62efcb15c51e0c4170eaa3b8ac4b4d5/ce7c8/sample_dashboard.png 1440w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of a dashboard using widgets</Caption>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <p>{`Each widget has a title bar and a content section. The title bar is standard for all widgets, but the content section varies depending on the type of widget.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "884px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.457013574660635%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABKElEQVQoz3WSjW6DMAyE+/6POG3SJq1AF6BACHH+fHVCgaprI30ycayLz+GEN4uZwSU+w1sBOMSdRL7E07YZ2h5t8wdVX0DaSM4hWhLcHSrkvDMWU69hhqWccQglz0kE801JRPWVMHS2RNIBTsd/UI7zipki+u4KMgHRMUj2zrAI5u4Ty2FAVRO6NmDR/BIrzBNDK4vxPOHcXOAprqNIKyLIRbBrPeraFqYhd3OI2IdvJRf+fLZQ3y1+LxUchW3qhV2wVQ5NI7b7gHlMu8hzh+OQ0El3S23wVX3Ayly3R8yrWE5RbEjhVWxnjNiiGW84zrp+kA7j8VfwfYYxrkXuDmnsVh/JNWMfoZQvI6oqD6MToge8Zbjl4VGCT0+8ym35Fe9iaeaYIXADIni/CSt5FoAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Widget Terminology",
        "title": "Widget Terminology",
        "src": "/static/02a2c5063d39d7f4087586540624ff89/f4587/widget_terminology.png",
        "srcSet": ["/static/02a2c5063d39d7f4087586540624ff89/1a057/widget_terminology.png 288w", "/static/02a2c5063d39d7f4087586540624ff89/8418d/widget_terminology.png 576w", "/static/02a2c5063d39d7f4087586540624ff89/f4587/widget_terminology.png 884w"],
        "sizes": "(max-width: 884px) 100vw, 884px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h4 {...{
      "id": "title"
    }}>{`Title`}</h4>
    <p>{`The tile identifies the widget. Max characters: 23 (including spaces)`}</p>
    <h4 {...{
      "id": "title-link"
    }}>{`Title link`}</h4>
    <p>{`A title link directs users to a more complete view of the information summarized in the widget. The link’s content should be as specific as possible (e.g., “View resources” instead of “View all”). Max characters: 15`}</p>
    <h4 {...{
      "id": "call-to-action"
    }}>{`Call-to-action`}</h4>
    <p>{`A call-to-action offers the user a quick action in the widget. The call-to action is optional and can incorporate a plus icon if appropriate. Max characters: 23`}</p>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <p>{`Dashboard widgets have two possible sizes, small and large. The height for both sizes is fixed at 310px. Neither widget is resizable.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variation type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Small widget (1:1)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Standard widget type`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Large widget (2:1)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Typically used to show data visualization`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Core widget`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Displayed on the dashboard by default and displays platform functionality`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Service widget`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Must be actively added to the dashboard by the user`}</td>
        </tr>
      </tbody>
    </table>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "60.83333333333334%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABlUlEQVQoz62Qy07CQBSG+25ufQJ3bEy8BReIYEJENF4SH8etC91IxIgaQkTKvbSl9xsIxvg7Z3CgsDLGJl8758w538yptLl/CCKRzGDnoIDs6SX2ji+QKpwxzmekWW43d8JrtzJ5bGePsJGm3jxWEymsrCWxnspBAnvCaITReIK/PtdlDVdFBZ9fgOSF75A7ChqMersHmUFrORbLbYVD+Ua3j7dWF13NwMD2oFkugjBENIwQDCeQ/Gg8E3b7OoqPL7gtPqBceUWHxU0mIFo9le/d3JVQqclQDZsLdSZUDQeq6SIcfUAia6MzbeooGp6rNZSeKrypzeKpUGVCjR9yz/aq9SbUgQ3D8bmQIDkX+sMxH4caSUwSulmb3UgcFN+jKWgaRTdhugEXCWY37A+sJeyFmMYjFN36wcTA8mB5IZcSlhtOhfSiq4tTaE2FYk1f0SRyIi9GXRiZXiIpNqhZxISQxHOi9l+Fy/KFkePQyIY9j8U/Wq6LYzrBXGg6HmzXh+OHrDGA60fspztwvAA2g/JU9xu+AfkqaiOlNruzAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Comparison of small and large widgets",
        "title": "Comparison of small and large widgets",
        "src": "/static/cb7c86e05b2ed259da7af505fa2fe06f/c801a/widget_dimensions.png",
        "srcSet": ["/static/cb7c86e05b2ed259da7af505fa2fe06f/1a057/widget_dimensions.png 288w", "/static/cb7c86e05b2ed259da7af505fa2fe06f/8418d/widget_dimensions.png 576w", "/static/cb7c86e05b2ed259da7af505fa2fe06f/c801a/widget_dimensions.png 1152w", "/static/cb7c86e05b2ed259da7af505fa2fe06f/ce7c8/widget_dimensions.png 1440w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Comparison between small and large widgets</Caption>
    <h3 {...{
      "id": "core-widget"
    }}>{`Core widget`}</h3>
    <p>{`Core widgets are displayed on the dashboard by default. They typically display platform functionality, such as maintenance events and support cases.`}</p>
    <h3 {...{
      "id": "service-widget"
    }}>{`Service widget`}</h3>
    <p>{`Service widgets must be added to the dashboard by a user. Users can add service widgets through a “Customize dashboard” menu.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      